import React, { Component } from 'react';
import Link from 'common/components/LocalizedLink/LocalizedLink';
import { injectIntl } from 'react-intl';
import { Helmet } from 'react-helmet';

import messages from './PageNotFoundView.intl';

import styles from './PageNotFoundView.module.scss';

import { Container, Title } from 'common/components/Layout/Layout';
import { ANCHOR } from 'common/consts/common';

import LanguageService from 'services/Language.service';

@injectIntl
export default class PageNotFoundView extends Component {
  render() {
    const currentLanguage = LanguageService.getLang();
    return (
      <div className={styles.PageNotFound}>
        <Helmet>
          <meta name="prerender-status-code" content="404" />
        </Helmet>
        <Container>
          <Title title={this.props.intl.formatMessage(messages.heading)} />
        </Container>
        <div className={styles.GreyBackground}>
          <Container>
            <div className={styles.MainContentBox}>
              <p className={styles.MainContentErrorText}>
                {this.props.intl.formatMessage(messages.warning)}
              </p>
              <Link to={ANCHOR.HOME[currentLanguage]}>
                <div className={styles.ReturnDiv}>
                  <i className={styles.ArrowLeft} />
                  <span className={styles.Return}>
                    {this.props.intl.formatMessage(messages.return)}
                  </span>
                </div>
              </Link>
            </div>
            <p className={styles.BackgroundText}>404</p>
          </Container>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/PageNotFound/PageNotFoundView.js